import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20floating%20film%20strips%20and%20soft%20golden%20spotlight%20beams%2C%20abstract%20artistic%20composition%20with%20warm%20amber%20tones%20against%20deep%20charcoal%20background%2C%20elegant%20minimalist%20design%2C%20high%20contrast%2C%20dramatic%20lighting%2C%20no%20text%2C%208k%20resolution%20quality&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="天堂影视 - 高清蓝光电影在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6 animate-fade-in-up">
            <i className="ri-fire-line text-primary-500 text-sm"></i>
            <span className="text-xs text-primary-400 font-medium">每日更新 · 高清蓝光 · 免广告</span>
          </div>

          <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight animate-fade-in-up animate-delay-100">
            电影大全免费在线观看
            <span className="block text-primary-400">高清蓝光不缓冲不卡顿</span>
          </h1>

          <p className="text-sm md:text-base text-foreground-300 max-w-xl mx-auto mb-8 leading-relaxed animate-fade-in-up animate-delay-200">
            天堂影视收录最新电影、高分电影，提供高清蓝光画质在线播放，免广告畅享观影体验，每日更新电影资源，让您随时随地畅享精彩影视内容。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center animate-fade-in-up animate-delay-300">
            <Link
              to="/category/action"
              className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold px-8 py-3 rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-play-circle-line text-base"></i>
              立即观影
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/20 px-8 py-3 rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10 flex-wrap animate-fade-in-up animate-delay-400">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-400">10000+</p>
              <p className="text-xs text-foreground-400 mt-1">电影资源</p>
            </div>
            <div className="w-px h-10 bg-background-50/10"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-400">4K</p>
              <p className="text-xs text-foreground-400 mt-1">蓝光画质</p>
            </div>
            <div className="w-px h-10 bg-background-50/10"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-400">0</p>
              <p className="text-xs text-foreground-400 mt-1">广告打扰</p>
            </div>
            <div className="w-px h-10 bg-background-50/10"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-400">每日</p>
              <p className="text-xs text-foreground-400 mt-1">资源更新</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2 rounded-full bg-background-50/50 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}